import Image from "../gui/Image";
import Modal from "../gui/Modal";
import AbstractDataHandler from "../shared/AbstractDataHandler";
import { getBaseUrl, getPlanPath, getPlanSlug, getUsername } from "../shared/utils";

export default class DataHandler extends AbstractDataHandler {
    redirectAfterSave = false;

    getData() {
        if (this.isNewPlan()) {
            let storageData = this.storage.get();
            let newData = this.loadData(storageData, storageData);
            storageData == null
                ? this.provider.showWelcomeMessage()
                : (
                    newData.showMigrationMessage
                        ? this.provider.showMigrationMessage() : null
                )
        } else {
            let uri = `${getBaseUrl(this.p)}/${getPlanSlug(this.p)}/data`;
            this.spinner.create(this.p.width / 2, this.p.height / 2, 200, this.backgroundColor, this.p.width, this.p.height);
            this.executeGetRequest(uri, (data) => {
                let newData = this.loadData(data, this.storage.get());
                this.imageMenu.opacitySlider.value(newData.image?.opacity || 255);
                if (newData.showMigrationMessage) {
                    this.provider.showMigrationMessage();
                }
            });
        }
    }

    loadLists(func) {
        let uri = `/${username}/plans/lists`;
        this.spinner.create(this.sideBar.x + this.sideBar.width / 2, 150, 80);
        this.executeGetRequest(uri, func);
    }

    savePlan() {
        if (!this.unsavedChanges) {
            return;
        }

        if (!this.isNewPlan()) {
            this.updatePlan();
        } else if (!username) {
            location.href = this.p.getURL().replace('/plans/new', '/users/sign_in');
        } else if (!this.settings.name) {
            this.askForName();
        } else {
            this.createPlan();
        }
    }

    askForName() {
        this.enableHotKeys = false;
        let nameModal = new Modal(this.provider);
        let nameInput = this.p.createInput('').class('input-text');
        nameModal.onClickOutside(() => {
            this.enableHotKeys = true;
            nameModal.remove()
        })
            .setTitle('Add a name')
            .addContent(nameInput)
            .setButtonText('Save')
            .onClickButton(() => {
                this.settings.name = nameInput.value();
                nameModal.remove();
                this.createPlan();
            });
    }

    createPlan(name) {
        let postData = this.getPostData();
        this.createSpinner();
        this.executeSaveRequest(
            '/plans',
            'POST',
            postData,
            (result) => {
                location.href = this.p.getURL().replace('/plans/new', result['uri']);
            });
    }

    updatePlan() {
        let uri = getPlanPath(this.p);
        this.redirectAfterSave = this.settings.name != this.planName;
        if (this.redirectAfterSave) {
            this.createSpinner();
        }
        this.executeSaveRequest(
            uri,
            'PATCH',
            this.getPostData(),
            (result) => {
                if (this.redirectAfterSave) {
                    location.href = this.p.getURL().replace(uri + '/edit', result['uri']);
                }
            });
    }

    deletePlan() {
        let uri = getPlanPath(this.p)
        this.createSpinner();
        this.p.httpDo(
            uri,
            {
                method: 'DELETE',
                headers: {
                    'X-CSRF-Token': this.p.select('meta[name="csrf-token"]').elt.content,
                    'Accept': 'application/json',
                }
            },
            (data) => {
                location.href = this.p.getURL().replace(uri + '/edit', '/' + getUsername(this.p) + '/plans');
            },
            (data) => {
                console.log(JSON.parse(data));
            }
        )
    }

    createSpinner() {
        this.spinner.create(this.p.width / 2, this.p.height / 2, 200, this.backgroundColor, this.p.width, this.p.height);
    }

    getPostData() {
        return {
            plan: {
                content: {
                    view: this.view.export(),
                    settings: this.settings.export(),
                    elements: this.elements.export(),
                    image: this.image?.export(),
                    version: 1,
                },
                name: this.settings.name,
                access: this.settings.access,
            }
        };
    }

    updateImage(file) {
        if (this.image) {
            this.deleteImage(this.image.id);
            this.image = null;
        }
        const formData = new FormData();
        formData.append('image[file]', file.file);

        fetch('/plans/image', {
            method: 'POST',
            headers: {
                'X-CSRF-Token': this.p.select('meta[name="csrf-token"]').elt.content,
                'Accept': 'application/json',
            },
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                this.image = new Image(this.provider, data, true);
            })
            .catch(error => {
                console.error(error);
            });
    }

    deleteImage(id) {
        fetch(`/plans/image/${id}`, {
            method: 'DELETE',
            headers: {
                'X-CSRF-Token': this.p.select('meta[name="csrf-token"]').elt.content,
                'Accept': 'application/json',
            },
        })
            .catch(error => {
                console.error(error);
            });
    }

    isNewPlan() {
        return this.p.getURLPath()[1] == 'new';
    }
};
